import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";


import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';



const restLink_dam = new HttpLink({ 
  uri: "/api/v1/dam/",
  credentials: 'include'
});
const dam_client = new ApolloClient({
  link: restLink_dam,
  cache: new InMemoryCache(),
});




const GET_CATEGORY = gql`{
  category_collections{
    categories{
      id
      title
      banner
    }
  }
}
`;




class CategoryList extends Component {

  
  render() {
    

  
    return (
        <div>
          
<Query
  client={dam_client}
  query={GET_CATEGORY}
  >
  {({ loading, error, data }) => {
    if (loading) return <tr><td>Carregando...</td></tr>;
    if (error) return <tr><td>Erro 1:(</td></tr>;

      var category_by_rows = [];
      var i = 1;
      var ii = 1;
      data.category_collections.categories.map((item) => {
        if(!category_by_rows[i]) {
          category_by_rows[i] = [];
        }
        category_by_rows[i].push(item);
        if(ii++ === 3) {
          ii = 1;
          i++;
        }
      });


      return category_by_rows.map((items_trail) => (

        <Row>
        {items_trail.map((item_category) => (
          
            <Col md={12}>
             
                      <div>
                    
                      <div key={item_category.id} className="course-item box-card">
                        <a 
                        data-gtm-type="click" 
                        data-gtm-clicktype="card" 
                        data-gtm-name={item_category.title}
                        href={"/#/home/"+item_category.id}>
                        <img src={"/dam/assets/"+(item_category.banner)} />
                        <div className="title">
                          {
                          //item_category.title
                          }
                          Clique para assistir
                        </div>
                        </a>
                      </div>
                        


                    </div>
                   
            </Col>

          ))}
          </Row>
        
      ));
      }}
      </Query>
      </div>
    );
  }
}

export default CategoryList;



// WEBPACK FOOTER //
// ./src/components/Category/List.jsx